<div *ngFor="let item of items" style="width: 100%">
  <mat-card fxFlex class="list-call-item clickable">
    <mat-card-title class="list-user-item-title">
      <div class="clickable">
        <small
          ><b>#{{ item.id }}</b></small
        >
      </div>
      <div class="clickable">
        <button mat-icon-button (click)="editUser(item.id)">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </mat-card-title>

    <div class="list-os-item-infos" style="margin-bottom: 0">
      <div>
        <b><small>Nome:</small></b> <br />
        {{ item.name }}
      </div>
      <div>
        <b> <small>Telefone:</small></b> <br />
        {{ apiService.nineExtra(item.mobile) | mask: apiService.phoneMask }}
      </div>
    </div>
  </mat-card>
</div>
